<ion-app>
  <app-response-notificaion></app-response-notificaion>
  <router-outlet></router-outlet>
</ion-app>